import { render, staticRenderFns } from "./reservations_history.vue?vue&type=template&id=6471d6a2"
import script from "./reservations_history.vue?vue&type=script&lang=js"
export * from "./reservations_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports